import React from "react";
import { makeStyles } from "@mui/styles";
import { Button, Link } from "@mui/material";

import PermissionCheck from "../PermissionCheck";
import { UserPermissions, LoginSupportInfoFormActions, FormActionStatus, CredentialResponse, Brand, mfaEnabledMap, MFAFactor, Partition } from "../../services/Types";
import UserCredentialsApi from "../../services/Api";
import FormActionStatusIcon from "../FormActionStatusIcon/FormActionStatusIcon";

const useStyles = makeStyles({
  passwordAndMfaHolder: {
    margin: "21px 0 0",
  },
  passwordContent: {
    margin: "7px 0 29px",
  },
  mfaHolder: {
    margin: "7px 0 0",
  },
  mfaTitle: {
    display: "inline-block",
  },
  mfaEnabled: {
    paddingLeft: "5px",
    color: "#323232",
  },
  mfaPhone: {
    paddingLeft: "20px",
  },
  resetPhoneHolder: {
    paddingLeft: "30px",
    position: "relative",
    display: "inline-block",
  },
  resetPhoneStatusIcon: {
    position: "absolute",
    left: "10px",
  }
});

export const PasswordAndMFASection = ({
  userCredentials,
  userPermissions,
  formActionsStatus,
  executeFormAction,
  userCredentialsApi,
  brand
}: {
  userCredentials: CredentialResponse;
  userPermissions: Array<UserPermissions>;
  formActionsStatus: LoginSupportInfoFormActions;
  executeFormAction: any;
  userCredentialsApi: UserCredentialsApi;
  brand?: Brand;
}) => {
  const classes = useStyles();

  const getConfirmedNumberFromMFAs = (
    mfaFactors: Array<MFAFactor> | undefined
  ): string | undefined => {
    return mfaFactors
      ?.filter(
        (mfaFactor) =>
          mfaFactor.confirmed &&
          (mfaFactor.type === "voice" || mfaFactor.type === "sms")
      )
      ?.pop()?.name;
  };

  const confirmedNumber = getConfirmedNumberFromMFAs(
    userCredentials?.mfaFactors
  );

  const isOktaUser = userCredentials?.partition === Partition.OKTA;

  return (
    <>
      {
        !isOktaUser &&
        <div className={classes.passwordAndMfaHolder}>
          <h3>Password Reset</h3>
          <PermissionCheck
            userPermissions={userPermissions}
            permissionToCheck={
              UserPermissions.SEND_RESET_PASSWORD_EMAIL
            }
          >
            <div className={classes.passwordContent}>
              <Button
                variant="outlined"
                onClick={() =>
                  formActionsStatus.passwordResetEmail ===
                  FormActionStatus.NO_ACTION && executeFormAction({
                    credentialId: userCredentials.id,
                    action: "passwordResetEmail",
                    apiMethodToCall:
                      userCredentialsApi.sendResetPasswordEmail,
                  })
                }
              >
                <i className="t-reset-password"></i>
                Send Password Reset
              </Button>
              <FormActionStatusIcon
                brand={brand}
                status={formActionsStatus.passwordResetEmail}
              />
            </div>
          </PermissionCheck>
          {confirmedNumber && (
            <div>
              <h4 className={classes.mfaTitle}>MFA Phone</h4>
              <span className={classes.mfaPhone}>
                {confirmedNumber}
              </span>
              <PermissionCheck
                userPermissions={userPermissions}
                permissionToCheck={
                  UserPermissions.RESET_REMOVE_MFA_PHONE_EDIT
                }
              >
                <span className={classes.resetPhoneHolder}>
                  <FormActionStatusIcon
                    brand={brand}
                    className={classes.resetPhoneStatusIcon}
                    status={formActionsStatus.resetPhone}
                  />
                  <Link
                    data-testid="phone-reset-link"
                    tabIndex={0}
                    onKeyDown={e => e.key === 'Enter' && executeFormAction({
                      credentialId: userCredentials.id,
                      action: "resetPhone",
                      apiMethodToCall:
                        userCredentialsApi.resetPhoneNumber,
                      newCredentialsState: {
                        ...userCredentials,
                        mfaFactors: [],
                      },
                    })}
                    onClick={e => executeFormAction({
                      credentialId: userCredentials.id,
                      action: "resetPhone",
                      apiMethodToCall:
                        userCredentialsApi.resetPhoneNumber,
                      newCredentialsState: {
                        ...userCredentials,
                        mfaFactors: [],
                      },
                    })}
                  >
                    Reset
                  </Link>
                </span>
              </PermissionCheck>
            </div>
          )}
        </div>
      }
    </>
  );
}